<template>
  <div :class="buttonRowClass">
    <label class="btn btn-success btn-file">
      {{label}}
      <input type="file" ref="fileUpload" style="display: none;" @change="onSelectFiles" :multiple="multiple" />
    </label>
    <label class="btn btn-secondary btn-file" @click="onClearFiles" v-if="files && files.length">
      Clear Files
    </label>
    <div class="row">
      <div v-for="(file, index) in files" :key="index" class="col-sm-6">
        <span>{{$formatters.truncate(file.name,36)}}</span>
        <button type="button" class="close" @click="onRemoveFile(index)"><span aria-hidden="true">&times;</span></button>
      </div>
    </div>


    <div v-if="fileError" class="alert alert-danger mt-2">{{fileError}}</div>
    <div class="error-div">
      {{validationMessage}}
    </div>
  </div>
</template>

<script>
import primitiveMixin from './primitive-mixin'

export default {
  mixins: [primitiveMixin],
  props: {
    label: String,
    multiple: {
      type: Boolean,
      default: false
    },
    buttonRowClass: {
      type: String,
      default: ""
    },
  },
  data() {
    return {
      files: [],
      fileError: null
    }
  },
  methods: {
    onSelectFiles() {
      if (this.$refs.fileUpload && this.$refs.fileUpload.files.length) {
        if (!this.multiple) {
          this.files = [];
        }

        this.fileError = null;

        const MAX_FILES_UPLOAD_SIZE = 29000000; // 29 Mb
        const files = [...this.files, ...Array.from(this.$refs.fileUpload.files)];
        const total = files.reduce((acc, file) => acc + file.size, 0);

        if (total > MAX_FILES_UPLOAD_SIZE) {
          this.fileError = "Total size of all files cannot exceed 29Mb";
          return;
        }

        this.files = [...this.files, ...Array.from(this.$refs.fileUpload.files)];

        this.$emit('change', this.files);
      }
    },
    onClearFiles() {
      this.files.splice(0);
    },
    onRemoveFile(fileIndex) {
      this.files.splice(fileIndex, 1);
    }
  },
}
</script>

<style scoped>
  .file {
    padding-bottom: 5px;
  }
</style>



// WEBPACK FOOTER //
// src/framework/primitives/AmfFileUpload.vue